import moment from 'moment';
import { IVoucher } from '@homeserve/vue-api-plugin';

export type VoucherValidity = 'invalid' | 'valid' | 'expired' | 'min_amount_not_reached' | 'already_used';

export function voucherValidity(voucher: IVoucher, price: number): VoucherValidity {
  if (!voucher) {
    return 'invalid';
  }
  if (voucher.startValidityDate && voucher.endValidityDate) {
    if (!moment().isBetween(moment(voucher.startValidityDate), moment(voucher.endValidityDate))) {
      return 'expired';
    }
  }
  if (voucher.minCartAmount > 0 && price < voucher.minCartAmount) {
    return 'min_amount_not_reached';
  }
  if (voucher.redemptionsAllowed > 0 && voucher.redemptionsAllowed <= voucher.redemptionsUsage) {
    return 'already_used';
  }
  return 'valid';
}

export function isVoucherValid(voucher: IVoucher, price: number) {
  return voucherValidity(voucher, price) === 'valid';
}
